import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import type { BlogCategory } from '@/types/blogCategory';

const BLOG_CATEGORIES_COLLECTION = 'blogCategories';

const firestoreDb: typeof db = db;

const slugify = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const blogCategoriesService = {
  async getAll(): Promise<BlogCategory[]> {
    const q = query(collection(firestoreDb, BLOG_CATEGORIES_COLLECTION), orderBy('sortOrder', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((item) => ({
      id: item.id,
      ...item.data(),
      createdAt: item.data().createdAt?.toDate(),
      updatedAt: item.data().updatedAt?.toDate(),
    })) as BlogCategory[];
  },

  async create(name: string, sortOrder = 0): Promise<string> {
    const cleanName = name.trim();
    if (!cleanName) {
      throw new Error('Category name is required');
    }

    const docRef = await addDoc(collection(firestoreDb, BLOG_CATEGORIES_COLLECTION), {
      name: cleanName,
      slug: slugify(cleanName),
      isActive: true,
      sortOrder,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    });

    return docRef.id;
  },

  async update(id: string, data: Partial<BlogCategory>): Promise<void> {
    const updateData: Record<string, unknown> = {
      ...data,
      updatedAt: Timestamp.now(),
    };

    if (typeof data.name === 'string') {
      updateData.name = data.name.trim();
      updateData.slug = slugify(data.name);
    }

    await updateDoc(doc(firestoreDb, BLOG_CATEGORIES_COLLECTION, id), updateData);
  },

  async delete(id: string): Promise<void> {
    await deleteDoc(doc(firestoreDb, BLOG_CATEGORIES_COLLECTION, id));
  },
};

